import * as React from "react";
import cx from "classnames";
import { IRoutedTab } from "./routed";

const styles = require("./vingleTab.scss");

interface IProps {
  tabs: Array<Vingle.ITab | IRoutedTab>;
  selectedTab: Vingle.ITab;
  vingleTabType: Vingle.VingleTabType;
  wrapperClassName?: string;
  onTabClick: (clickedTab: Vingle.ITab) => void;
}

class TabPage extends React.PureComponent<IProps> {
  public render() {
    const {
      selectedTab,
      tabs,
      wrapperClassName,
      onTabClick,
      vingleTabType,
      ...rest
    } = this.props;

    const tabWrapperClass =
      vingleTabType === "main" ? styles.mainTabWrapper : styles.subTabWrapper;
    const tabMenu = tabs.map(tab => {
      return (
        <div
          key={`vingleTab-${tab.key}`}
          className={cx(styles.tab, {
            [styles.selected]: tab.key === selectedTab.key,
          })}
          data-tab={tab.key}
          onClick={this.handleTabClick}
        >
          <span className={styles.textBox}>{tab.title}</span>
          <div className={styles.underline} />
        </div>
      );
    });

    return (
      <div className={wrapperClassName}>
        <div className={tabWrapperClass}>{tabMenu}</div>
        <div className={styles.container}>
          <selectedTab.page {...rest} />
        </div>
      </div>
    );
  }

  private readonly handleTabClick: React.MouseEventHandler<
    HTMLDivElement
  > = e => {
    const tabKey = e.currentTarget.getAttribute("data-tab");
    const clickedTab = this.props.tabs.find(tab => {
      return tab.key === tabKey;
    });
    if (clickedTab) {
      this.props.onTabClick(clickedTab);
    }
  };
}

export default TabPage;
